<template>
  <div>
    <report-va :base_info="base_info"></report-va>
  </div>
</template>
<script>
import reportVa from "./ReportVa.vue";

export default {
  name: "reportApprove",
  components: {
    reportVa
  },
  data() {
    return {
      base_info: {
        title_ch: "待批准报告",
        op_title: "批准",
        post_url: "/ask_list_data",
        askData: "reportToApprove",
        opAskData:'approve'
      },
      
    };
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>
<style scoped>
</style>